module.exports = __webpack_public_path__ + "static/media/solucoes.85b77996.jpeg";